import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectElectronicTradingFilter } from 'shared/selectors/advancedFilters';

export const ElectronicTradingContainer: FC = () => {
  const { label, value, options } = useSelector(selectElectronicTradingFilter);

  const onChange = useFilterChangeCallback();

  const handleElectronicTradingChange = useCallback(
    (newValue: number | null) => {
      onChange({ action: 'setElectronicTradingType', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <SingleSelectionAdvancedFilter options={options} value={value} onFilterChange={handleElectronicTradingChange} />
    </AdvancedFilterRow>
  );
};
